export default __webpack_public_path__ + "static/media/apple-sales-quarter.ce2fd403.csv";